import { render, staticRenderFns } from "./CustomerCrmSubjectSettings.vue?vue&type=template&id=c68401be&scoped=true&"
import script from "./CustomerCrmSubjectSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmSubjectSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68401be",
  null
  
)

export default component.exports